import React from 'react'

export default function Footer() {
    const currentYear = new Date().getFullYear();
    return ( 
        <div>
            <div className="container  my-4">
                <footer className=" my-4">
                    <p className="text-center text-muted">© {currentYear} Jambh Bhakti WordCounter</p>
                </footer>
            </div>
    </div>
    )
}